import { ClientAccessStatusResponse } from '@interfaces/partners/responses/client-access.response';

/** Selo do card "Acesso do cliente" (card 3461). */
export interface ClientAccessBadge {
  label: string;
  tone: 'success' | 'warning' | 'neutral';
}

/**
 * O termo assinado vence o convite: "NDA assinado" diz que o objetivo do acesso já foi cumprido.
 * Sem termo assinado, ter usuário criado é "convite enviado"; sem usuário, "sem acesso ainda".
 */
export function clientAccessBadge(
  status: ClientAccessStatusResponse | null | undefined
): ClientAccessBadge {
  if (status?.termStatus === 'Assinado') return { label: 'NDA assinado', tone: 'success' };
  if (status?.users?.length) return { label: 'convite enviado', tone: 'warning' };
  return { label: 'sem acesso ainda', tone: 'neutral' };
}
